import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {HttpInterceptorService} from "../../../../app/core/services/http-interceptor.service";
import {Widget} from "../../../widgets/decorator/widget.decorator";
import {IWidgetItem} from "../../../widgets/interfaces/widget-item.interface";
import {IdynamicFormItem} from "../../../../app/shared/dynamic-form/interfaces/IdynamicFormItem";
import {get, last, set} from 'lodash';
import {BundleCall} from "../../../aggregator/services";
import {InterpolateService} from "@ispm/shared/services/interpolate.service";
import {Subject} from "rxjs";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'ispm-enrolled-tests',
  templateUrl: './enrolled-tests.component.html',
  styleUrls: ['./enrolled-tests.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('EnrolledTests')
export class EnrolledTestsComponent implements OnInit, IWidgetItem {
  widgetUpdateValueCallback: (value) => void;
  @Input() data: any = [];
  @Input() config: any;
  @Input() patientId: string;
  private testName: string;
  private fieldList: string;
  private resourceType: string;
  private showCount: number;
  public redirectUrl: string;
  private readonly stateParams: any = {};
  private destroyed$: Subject<any> = new Subject();

  constructor(private _http: HttpInterceptorService,
              private _bundleCall: BundleCall,
              private _changeDetectorRef: ChangeDetectorRef,
              private _interpolateService: InterpolateService,
              private routerManagerService: RouterManagerService) {
    this.stateParams = this.routerManagerService.parameters;
  }

  widgetData: any;

  set widgetConfig(_widgetConfig: IdynamicFormItem<any>) {
    this.config = get(_widgetConfig, 'widgetPayload');
    this.testName = get(this.config, 'testName', '');
    this.fieldList = get(this.config, 'fieldList', 'id');
    if (this.testName && Array.isArray(this.testName)) {
      this.testName = this.testName.join(',');
    }
    this.showCount = get(this.config, 'showCount');
    this.redirectUrl = get(this.config, 'redirectUrl');
    this.resourceType = get(this.config, 'resourceType', 'DiagnosticOrder');
  }

  ngOnInit(): void {
    if (!this.patientId) {
      this.patientId = this.stateParams.patientId;
    }

    this.prepareTestsData();
  }

  prepareTestsData() {
    this._http.get(`/${this.resourceType}?subject=${this.patientId}&_fieldslist=${this.fieldList}`)
      .takeUntil(this.destroyed$.asObservable())
      .map(resp => resp.json())
      .subscribe((allOrders: any) => {
        let tempAllOrders = [];
        if (allOrders && allOrders.length > 0) {
          let workflowRequestIds = allOrders.map(order => order.workflowRequest);
          const workflowRequestPayload = {
            'queries': [{
              'targetResource': 'WorkflowRequest',
              'queryString': `_id=${workflowRequestIds.join(',')}&name=${this.testName}&_fieldslist=name,latestRevisionStatus,status,activeRevision,revisions`
            }]
          };
          this._bundleCall.searchCall(workflowRequestPayload)
            .takeUntil(this.destroyed$.asObservable())
            .subscribe(data => {
            let allTests = get(data, '[0].response.entry');
            if (allTests && allTests.length > 0) {
              allTests = allTests.map(test => {
                let workflowRequest = get(test, 'resource');
                if (get(workflowRequest, 'activeRevision', 'None') == "None") {
                  let latestRevision = last(get(workflowRequest, 'revisions', []))
                  set(workflowRequest, 'activeRevision', get(latestRevision, 'id'))
                }
                delete workflowRequest['revisions'];
                let tempOrder = allOrders.find(tempOrder => get(tempOrder, 'workflowRequest') === get(workflowRequest, 'id'));
                return {...tempOrder, ...workflowRequest}
              });
              this.data = allTests || [];
              if (this.showCount) {
                this.data = this.data.slice(0, this.showCount);
              }
              this.widgetUpdateValueCallback(this.data);
              this._changeDetectorRef.detectChanges();
              this._changeDetectorRef.markForCheck();
            }
          });
        } else {
          this.widgetUpdateValueCallback([]);
          this._changeDetectorRef.detectChanges();
          this._changeDetectorRef.markForCheck();
        }
      });

  }

  /**
   * Navigate test page
   * @param data
   */
  onTestRowClick(data: any) {
    if(this.redirectUrl) {
      const interpolatedParamsFromUrl = this._interpolateService.interpolate(this.redirectUrl, get(data, 'item', {}));
      const url = window.document.location.origin + interpolatedParamsFromUrl;
      window.open(url, '_blank');
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
